module.exports = __webpack_public_path__ + "media/images/emblems/Fontaines-sur-Grandson-coat_of_arms-6a87be277e58d12b534a2f9b0fa29f17.svg";